import { render, staticRenderFns } from "./CategoryStructuredData.vue?vue&type=template&id=7344181a"
import script from "./CategoryStructuredData.vue?vue&type=script&lang=js"
export * from "./CategoryStructuredData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports